<header class="ib-header-steps">
    <div class="container">
        <div class="row">
            <div class="col-xs-12">
                <div class="ib-header-steps__content">
                    <div class="ib-header-steps__block--left">
                            <figure class="ib-header-steps__fig">
                                <img [src]="imgUrl + '/logos/logo_iberia_red.svg'" alt="Logo Iberia" />
                            </figure>
                        <div class="ib-header-steps__content--bordered">
                            <span class="ib-header-steps__txt">
                                 {{headerModel?.title | translate}}
                            </span>
                            <span *ngIf="headerModel?.steps" class="ib-header-steps__txt--short visible-sm-inline-block visible-xs-inline-block">
                                {{ headerModel.steps.activeStep }} / {{ headerModel.steps.stepNames.length }}
                            </span>
                        </div>
                    </div>
                    <div class="ib-header-steps__block--right">
                        <a href="javascript:void(0)" (click)="cancelModal()" class="ib-header-steps__link icon-cerrar">
                            {{headerModel?.closeText | translate}}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="headerModel?.steps" class="ib-main-steps ib-main-steps--flex hidden-sm hidden-xs">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 ib-main-steps__scroll">
                    <ul class="ib-main-steps__list--flex">
                        <li *ngFor="let step of headerModel.steps.stepNames; index as i" class="ib-main-steps__item--flex">
                            <span
                                class="ib-main-steps__txt--flex"
                                [ngClass]="{'ib-main-steps__txt--active' : headerModel.steps.activeStep === i + 1}">
                                    {{ i+1 }}. {{ step |translate}}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>